import { createContext, useContext } from "react";

const CookieConsentContext = createContext({
  openManageCookies: () => {},
});

export const useCookieConsent = () => useContext(CookieConsentContext);

export default CookieConsentContext;
